"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoryStorage = exports.MemoryStorage = void 0;
class MemoryStorage {
    constructor() {
        this.data = new Map();
    }
    get length() {
        return this.data.size;
    }
    setObject(name, value) {
        // Log.info('[memoryStorage.setObject]', name, value);
        this.data.set(name, value);
    }
    getObject(name) {
        // Log.info('[memoryStorage.getObject]', name);
        return this.data.get(name);
    }
    key(_index) {
        return Array.from(this.data.keys())[_index];
    }
    setItem(name, value) {
        // Log.info('[memoryStorage.setItem]', name, value);
        this.data.set(name, value);
    }
    getItem(name) {
        // Log.info('[memoryStorage.getItem]', name);
        return this.data.get(name) || null;
    }
    removeItem(name) {
        // Log.info('[memoryStorage.removeItem]', name);
        this.data.delete(name);
    }
    clear() {
        // Log.info('[memoryStorage.clear]');
        this.data.clear();
    }
}
exports.MemoryStorage = MemoryStorage;
// @deprecated, won't have to be used
exports.memoryStorage = new MemoryStorage();
//# sourceMappingURL=memoryStorage.js.map